import React, { useEffect, useState } from "react";
const MOBILE_BREAKPOINT = 768;

function useWindow() {
    const [isMobile, setIsMobile] = useState(typeof window != "undefined" ? window.innerWidth <= MOBILE_BREAKPOINT : false);

    function handleWindowResize() {
        setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT)
    }

    useEffect(() => {
        handleWindowResize();
        window.addEventListener("resize", handleWindowResize);

        return () => {
            window.removeEventListener("resize", handleWindowResize);
        }
    }, []);

    return {
        isMobile
    }
}

export {useWindow}


// WEBPACK FOOTER //
// ./src/hooks/useWindow.js